module.exports = __webpack_public_path__ + "static/ava-digital-badge.ea889dbd.webp";